Auth = require 'db/auth'
Promise = require 'bluebird'
xtend = require 'xtend'
$ = require "jquery"

trelloDomain = window.slackTrelloDomain
slackDomain = window.slackDomain
slackKey = "7737388dfc54ea015104894e3a0a56f9"
token = ""

createPromise = (opts) ->
  new Promise (resolve, reject) ->
    opts = xtend opts,
      success: (args...) ->
        resolve(args)
        return
      error: (args...) ->
        reject(args)
        return
    $.ajax opts
    return

module.exports.ajaxTrello = (opts) ->
  opts.url = trelloDomain + opts.url

  opts.data ?= {}
  opts.data.cookie = document.cookie
  createPromise(opts)



// WEBPACK FOOTER //
// ./app/scripts/network/slack-ajax.coffee